import { GetStaticPaths } from 'next';
import EducationSectionHub, { getStaticProps } from '..';

export { getStaticProps };

export const getStaticPaths: GetStaticPaths = () => {
  if (process.env.TEST) {
    return {
      fallback: 'blocking',
      paths: [],
    };
  }

  return {
    fallback: 'blocking',
    paths: [
      {
        params: {
          pageNum: '2',
        },
      },
    ],
  };
};

export default EducationSectionHub;
